import React from 'react';
import PropTypes from 'prop-types';

const ListHeader = props => (
  <div className="pf-c-dual-list-selector__header">
    <div className="pf-c-dual-list-selector__title">
      <div className="pf-c-dual-list-selector__title-text">{props.title}</div>
    </div>
  </div>
);

ListHeader.propTypes = {
  title: PropTypes.string.isRequired,
};

export default ListHeader;



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_ansible-9.0.1-1.fm3_4.el8.noarch/usr/share/gems/gems/foreman_ansible-9.0.1/webpack/components/DualList/ListHeader.js